import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React, {useState} from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import './assets/fonts/Stag-Medium.otf';
import './index.css';
import './i18n';
import {v4 as uuid} from 'uuid';
import axios from 'axios';
import {_sendLog} from './utils/utility'

import createAppStore from './store/app-store';
import App from "./App";

// Wraps App in a fresh Redux store
function ReactReduxApp() {
    const [store] = useState(createAppStore);
    generateUuid();

    return (
        <Provider store={store}>
            <App/>
        </Provider>
    );
}

function generateUuid() {
    if (process.env.REACT_APP_ENV && process.env.REACT_APP_ENV  !== 'dev') {
        const sessionId = uuid();
        console.log('Generated UUID: ' + sessionId);
        _sendLog('SME-React - generateUuid - Generated UUID: ' + sessionId, 'info')
        axios.interceptors.request.use((request = {}) => {
            if (request?.params?.hasOwnProperty('handlerEnabled') && !request?.params?.handlerEnabled) {
                delete request.params.handlerEnabled;
                return request;
            }
            request.headers['Session-Name'] = sessionId;
            return request;
        });
        axios.interceptors.response.use(null, (error) => {
            const requestConfigData = error.config.data;
            const requestConfigHeaders = error.config.headers;
            const requestConfigUrl = error.config.url;
            const requestResponseUrl = error.request.responseURL;
            const requestResponseStatus = error.request.status;

            _sendLog(['SME React sme-react - ' + requestConfigUrl,
                ' SessionID: ' + sessionId,
                ' Request Data: ' + requestConfigData,
                ' Request Header: ' +  JSON.stringify(requestConfigHeaders),
                ' Response URL: ' + requestResponseUrl,
                ' Status: ' + requestResponseStatus
            ]);
            return Promise.reject(error);
        });
    }
}

ReactDOM.render(
    (
        <ReactReduxApp/>
    ),
    document.getElementById('root')
);
